<script>
import axios from "axios";
import {toast} from "vue3-toastify";
import modalKkMixin from "../conversation-club/modal-kk-mixin.js";
import vSelect from "vue-select";
import _ from "lodash";


export default {
  name: "vyuka-form",
  components: {vSelect},
  props: ['lesson', 'btyp'],
  mixins: [modalKkMixin],

  data() {
    return {
      options:[],
      showModalFlag: false,
      isLoading: false,
      selected_student:{},
      lectors: [],
    };
  },
  watch: {
    lesson: {
      handler(newLesson) {
        if (newLesson) {
          if (newLesson.students) {
            const selected = {};
            newLesson.students.forEach(student => {
              selected[student.id] = student;
            });
            this.selected_student = selected;
          } else {
            this.selected_student = {};
          }
          // Nastaví hodnotu pro pole s kreditem na aktuální celkový kredit
          if (this.lesson.change_credit == undefined) this.lesson.change_credit = newLesson.credit;
        } else {
          this.selected_student = {};
        }
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {
    this.loadLectors()

  },



  methods: {
    removeStudent(index) {
      const studentToRemove = this.lesson.students[index];
      if (studentToRemove) {
        delete this.selected_student[studentToRemove.id];
      }
      this.lesson.students.splice(index, 1);
    },
    addNewStudentSlot() {
      if (!this.lesson.students) {
        this.lesson.students = [];
      }
      const tempId = `new_record_${Date.now()}`;
      this.lesson.students.push({ id: tempId, is_new_record: true, email: '', name: '', surname: '' });
    },
    addStudentSlot() {
      if (!this.lesson.students) {
        this.lesson.students = [];
      }
      // Použijeme dočasné ID pro klíč a v-model
      const tempId = `new_${Date.now()}`;
      this.lesson.students.push({ id: tempId, is_new: true });
      this.selected_student[tempId] = null;
    },
    onSearch(search, loading) {
      if(search.length) {
        loading(true);
        this.search(loading, search, this);
      }
    },

    search: _.debounce((loading, search, vm) => {
      fetch(
          `/ll/students/all?q=${escape(search)}`
      ).then(res => {
        res.json().then(json => (vm.options = json.items));
        loading(false);
      });
    }, 350),


    async loadLectors() {
      const r2 = await axios.get('/conversation-clubs/lectors.json', {
        params: {
          //level: this.lesson.level
          per: 100
        }
      })
      this.lectors = r2.data.items
    }
    ,
    sendData() {
      const finalStudents = this.lesson.students.map(studentSlot => {
        if (studentSlot.is_new_record) {
          return studentSlot; // Nový záznam studenta
        }
        // Pro existující sloty (původní i nově přidané)
        const selectedStudent = this.selected_student[studentSlot.id];
        return selectedStudent ? { id: selectedStudent.id, email: selectedStudent.email, name: selectedStudent.name, surname: selectedStudent.surname } : null;
      }).filter(s => s !== null); // Odstraníme prázdné sloty

      const lesson = { ...this.lesson,
        b_type: this.btyp,
        students: finalStudents };


      const url = lesson.id && !lesson.is_new_record ? `/ll/students/lessons/${lesson.id}.json` : '/ll/students/lessons.json';
      const method = lesson.id ? 'patch' : 'post';


      axios({ method, url, data: { lesson } })
          .then(response => {
            this.$emit('save-lesson', lesson);
            this.hideModal();
            toast.success("Údaje o výuce byly uloženy.");


          })
          .catch(error => {
            console.error('Došlo k chybě při ukládání lekce:', error);
            toast.error("Došlo k chybě při ukládání lekce.");
          });






    }
  }


}
</script>

<template>
  <vue-final-modal v-model="showM" classes="modal-container" content-class="modal-content-f w900">
    <div class="modal-header">
      <h5 class="modal-title">Výuka</h5>
      <button type="button" class="close" @click="hideModal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal__content">
      <!-- e-mail	name	surname	Company	Lecturer	Types of lesons	Grou name	Language level	Preferred time	How many minutes	number of lessons per month-->

      <div class="row">

        <div class="col-md-4">
          <div class="form-group">
            <label>Lektor</label>
            <select class="form-control" v-model="lesson.lector_id">
              <option></option>
              <option v-for="t in lectors" :value="t.id">{{ t.first_name }} {{ t.last_name }}</option>
            </select>
          </div>
        </div>


        <div class="col-md-3">
          <div class="form-group">
            <label>Types of lesons</label>
            <select class="form-control" v-model="lesson.lesson_type" :disabled="btyp==='b2c'">
              <option></option>
              <option value="one_to_one">jeden na jednoho</option>
              <option value="two_students"> párová lekce</option>
              <option value="group">skupinová lekce</option>
            </select>
          </div>
        </div>


        <div class="col-md-2">
          <div class="form-group">

            <label>Úroveň</label>


            <select class="form-control" v-model="lesson.language_level">
              <option></option>
              <option value="A1">A1</option>
              <option value="A2">A2</option>
              <option value="B1">B1</option>
              <option value="B2">B2</option>
              <option value="C1">C1</option>
              <option value="C2">C2</option>
            </select>

          </div>
        </div>


        <div class="col-md-3">
          <div class="form-group">
            <label>Jazyk</label>
            <select class="form-control" v-model="lesson.language_id">
              <option></option>
              <option value="1">čeština</option>
              <option value="2">angličtina</option>
              <option value="3">němčina</option>
              <option value="4">francouzština</option>
              <option value="5">španělština</option>
              <option value="6">ruština</option>
              <option value="7">italština</option>
              <option value="8">slovenština</option>
              <option value="10">polština</option>
            </select>
          </div>
        </div>




      </div>

      <div class="row">

        <div class="col-md-4">


          <div class="form-group">
            <label>How many minutes</label>
            <select class="form-control" v-model="lesson.minutes">
              <option></option>
              <option value="30">30 min (poloviční)</option>
              <option value="45">45 min</option>
              <option value="60">60 min</option>
            </select>

          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label>Preferred time</label>
            <select class="form-control" v-model="lesson.preferred_time">
              <option></option>
              <option value="weekday_morning">Po-Pá ráno</option>
              <option value="weekday_afternoon">Po-Pá odpoledne</option>
              <option value="weekday_evening">Po-Pá večer</option>
              <option value="weekend">Víkend</option>
            </select>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label>Number of lessons per month</label>
            <input type="number" class="form-control" v-model="lesson.lessons_per_month" placeholder=""/>
            <small class="form-text text-muted">0 = Flexible</small>
          </div>
        </div>

      </div>

      <div class="row">


        <div class="col-md-4">
          <div class="form-group">
            <label>Celkový kredit</label>
            <input type="number" class="form-control" v-model="lesson.change_credit" />
          </div>
        </div>

      </div>


      <div v-for="(student, index) in lesson.students" :key="student.id || index"
           class="form-group">
        <label>Student</label>
        <div class="d-flex align-items-center">
          <div class="flex-grow-1">
            <div v-if="!student.is_new_record">
              <v-select v-model="selected_student[student.id]" @search="onSearch" :filterable="false" :options="options" >

                <template #option="option">
                  <div class="d-flex">
                    <div class="">{{ option.email }}</div>
                    <div class="ml-2"><b>{{ option.name }} {{ option.surname }}</b></div>
                  </div>
                </template>
                <template #selected-option="option">
                  <div class="d-flex">
                    <div class="">{{ option.email }}</div>
                    <div class="ml-2"><b>{{ option.name }} {{ option.surname }}</b></div>
                  </div>
                </template>
              </v-select>
            </div>
            <div v-else>
              <div class="row">
                <div class="col-md-4"><input type="email" v-model="student.email" placeholder="Email" class="form-control"></div>
                <div class="col-md-4"><input type="text" v-model="student.name" placeholder="Jméno" class="form-control"></div>
                <div class="col-md-4"><input type="text" v-model="student.surname" placeholder="Příjmení" class="form-control"></div>
              </div>
            </div>
          </div>
          <div class="ml-2">
            <button @click="removeStudent(index)" class="btn btn-sm btn-danger">
              <i class="fas fa-times"></i>
            </button>
          </div>
        </div>
      </div>

      <div class="mb-3" v-if="lesson.lesson_type === 'two_students' || lesson.lesson_type === 'group' || (lesson.students && lesson.students.length === 0)">
        <button class="btn btn-sm btn-outline-primary mr-2" @click="addStudentSlot">
          <i class="fas fa-plus"></i> Přidat existujícího studenta
        </button>
        <button class="btn btn-sm btn-outline-success" @click="addNewStudentSlot">
          <i class="fas fa-user-plus"></i> Přidat nového studenta
        </button>
      </div>

    </div>
    <div class="modal-footer">
      <button @click="hideModal" type="button" class="btn btn-outline-dark">Zrušit</button>
      <button @click="sendData" class="btn btn-success">
        Uložit změny
      </button>
    </div>
  </vue-final-modal>
</template>

<style scoped>

</style>